

const bulkslider = () =>{
    var slideshowEle = document.querySelector('.sliders_main_wrapper');
    if(slideshowEle) {
        var swiperOptions = JSON.parse(slideshowEle.dataset.sliderOptions);
        collectionswiper = new Swiper(slideshowEle,swiperOptions);
        // pause slideshow on block select
        if (Shopify.designMode) {
          document.addEventListener('shopify:block:select', (e) => {
            var shopifyData = JSON.parse(e.target.dataset.shopifyEditorBlock),
                targetEle = e.target,
                sliderIndex = 1 + parseInt(targetEle.dataset.swiperSlideIndex);
                collectionswiper.slideTo(sliderIndex);
          })
          const customizationEvents = ['shopify:inspector:activate','shopify:inspector:deactivate','shopify:section:load','shopify:block:deselect','shopify:section:reorder','shopify:section:select','shopify:section:deselect','shopify:inspector:activate','shopify:inspector:deactivate'];
  
          customizationEvents.forEach(event => {
            document.addEventListener(event, () => collectionswiper.init(swiperOptions));  
          })
        }
    }
  } 
  
  
  document.addEventListener('DOMContentLoaded', () => {
    bulkslider();
  });